import { CFImage, CFVideo } from '../../type/client-index'

export const DelbovePresentation: CFImage = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/bf637153-aacd-48af-0eec-e0f62772c800/1750',
  width: 1750,
  height: 1166
}

export const Delbove1: CFImage = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/42c74b88-ee47-40e6-62fd-7520a3a37700/1750',
  width: 667,
  height: 1000
}

export const Delbove2: CFImage = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/bd3dd06d-51de-4609-3d4c-dc000653c100/1750',
  width: 667,
  height: 1000
}

export const Delbove3: CFImage = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/5e9dbdde-f8a8-43c7-0d37-bd720ad0b200/1750',
  width: 667,
  height: 1000
}

export const Delbove4: CFImage = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/7c23a199-937a-46ea-ea73-b6c1dd947600/1750',
  width: 667,
  height: 1000
}

export const Delbove5: CFImage = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/2b121941-b08f-4c7a-eea3-889d31817f00/1750',
  width: 667,
  height: 1000
}

export const Delbove6: CFImage = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/06de5f90-35d3-4b94-f2e8-9936b99ff600/1750',
  width: 667,
  height: 1000
}

// VIDEO

export const Reel1: CFVideo = {
  id: '0a8fa2c2af0c25bc7dc67aad3b6d9aeb',
  cover: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/255b99a8-ec45-4b67-a3f4-7a4fe0005f00/1750'
}

export const Reel2: CFVideo = {
  id: '608c9de938efe5dcb6c727a8329ef80a',
  cover: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/cc8852ca-c86d-48cf-19af-cf3d41ae0800/1750'
}
